import { FunctionalElement, FUNCTIONAL_ELEMENT_TYPE } from './functional-element';

export enum REPLACEMENT_OR_LAST_PROCEDURE_DATE_SELECTION {
    NONE = 'NONE',
    STARTUP_DATE = 'STARTUP_DATE',
    OTHER_DATE = 'OTHER_DATE',
}

// REPLACEMENT_DATE and LAST_PROCEDURE_DATE are identical in usage, so we use the same functional element for both
export type ReplacementOrLastProcedureDate = Readonly<{
    startupDateLabel: string;
    radioButtonXmlId: string;
    replacementDateLabel: string;
    selected: REPLACEMENT_OR_LAST_PROCEDURE_DATE_SELECTION;
    date: string;
    dayXmlId: string;
    monthXmlId: string;
    yearXmlId: string;
    type: FUNCTIONAL_ELEMENT_TYPE.REPLACEMENT_DATE | FUNCTIONAL_ELEMENT_TYPE.LAST_PROCEDURE_DATE;
}> &
    FunctionalElement;

export const initialReplacementDateType: ReplacementOrLastProcedureDate = {
    parentId: -1,
    id: -1,
    startupDateLabel: '',
    replacementDateLabel: '',
    radioButtonXmlId: '',
    selected: REPLACEMENT_OR_LAST_PROCEDURE_DATE_SELECTION.NONE,
    date: '',
    dayXmlId: '',
    monthXmlId: '',
    yearXmlId: '',
    controllingCheckpoint: '',
    disabled: false,
    type: FUNCTIONAL_ELEMENT_TYPE.REPLACEMENT_DATE,
    contentLoadedFromXml: false,
    controllingOption: undefined,
};

export const initialLastProcedureDateType: ReplacementOrLastProcedureDate = {
    parentId: -1,
    id: -1,
    startupDateLabel: '',
    replacementDateLabel: '',
    radioButtonXmlId: '',
    selected: REPLACEMENT_OR_LAST_PROCEDURE_DATE_SELECTION.NONE,
    date: '',
    dayXmlId: '',
    monthXmlId: '',
    yearXmlId: '',
    controllingCheckpoint: '',
    disabled: false,
    type: FUNCTIONAL_ELEMENT_TYPE.LAST_PROCEDURE_DATE,
    contentLoadedFromXml: false,
    controllingOption: undefined,
};

export function isReplacementDateOrLastProcedureDate(f: FunctionalElement): f is ReplacementOrLastProcedureDate {
    return (
        f.type === FUNCTIONAL_ELEMENT_TYPE.REPLACEMENT_DATE || f.type === FUNCTIONAL_ELEMENT_TYPE.LAST_PROCEDURE_DATE
    );
}
